import { Context, Logger } from '@vue-storefront/core';

import { GetTokenParams, IUseInvoiceAuthRefs } from '../types';
import { isAxiosError } from 'axios';

const getToken =
  (context: Context, refs: IUseInvoiceAuthRefs) => async (params: GetTokenParams) => {
    Logger.debug(`useInvoice/getToken`);

    refs.error.value = null;
    try {
      refs.loading.value = true;
      refs.hasToken.value = await context.$xero.api.getToken(params);
      refs.error.value = null;
    } catch (error) {
      if (isAxiosError(error)) {
        refs.error.value = error.response?.data;
      } else {
        refs.error.value = error as Error;
      }
      Logger.error(`useInvoice/getInvoiceAuth/error`, error);
    } finally {
      refs.loading.value = false;
    }
  };

export default getToken;
